module.exports = __webpack_public_path__ + "img/10.a9a6cd57.jpg";